import { render, staticRenderFns } from "./CategoryCustomOld.vue?vue&type=template&id=864745f4&scoped=true"
import script from "./CategoryCustomOld.vue?vue&type=script&lang=js"
export * from "./CategoryCustomOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864745f4",
  null
  
)

export default component.exports